export const fetchWithRetry = (operation: Promise<any>, waitTime = 10, maxRetries = 3): Promise<any> =>
    new Promise((resolve, reject) => {
        const wait = (wt: number) => new Promise((r) => setTimeout(r, wt));
        return operation
            .then((data: unknown) => {
                resolve(data);
            })
            .catch((reason: any) => {
                if (maxRetries > 0) {
                    return wait(waitTime)
                        .then(fetchWithRetry.bind(null, operation, waitTime, maxRetries - 1))
                        .then(resolve)
                        .catch(reject);
                }
                return reject(reason);
            });
    });
